// angular
import { Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
// components
import { TextSummarizerComponent } from '../text-summarizer/text-summarizer.component';
// pipes
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';
// interfaces
import { ITender } from '@app/+tenders/shared/interfaces/tender.interface';

@Component({
  selector: 'pwj-tender-card',
  templateUrl: './tender-card.component.html',
  standalone: true,
  imports: [
    RouterLink,
    CommonModule,
    TranslateModule,
    TextSummarizerComponent,
    TranslateDataPipe,
  ],
  styleUrls: ['./tender-card.component.scss'],
})
export class TenderCardComponent {
  data = input.required<ITender>();
  requirementText = input<string>('home.tendersSection.defaultRequirement');

  private readonly _translateService = inject(TranslateService);

  estimatedBudget = computed(() => {
    const amount = this.data()?.amount;
    if (!amount?.value) {
      return '';
    }

    const unitKey = amount.unit
      ? this._translateService.instant(`enums.measurements.${amount.unit}`)
      : '';

    return unitKey ? `${amount.value} ${unitKey}` : `${amount.value}`;
  });
}
